module.exports = __webpack_public_path__ + "img/ico-briefcase-search-outline-grey.68443b0f.svg";